import React, { Component } from "react";
import SalesUploadBody from "./SalesUploadBody";
import SalesRegisterBody from "./SalesRegisterBody";

class SalesRegister extends Component {
  render() {
    return (
      <div className="animated fadeIn">
        <SalesRegisterBody />
      </div>
    );
  }
}

export default SalesRegister;



// WEBPACK FOOTER //
// ./src/components/CustomComponents/SalesRegister.js